<script lang="ts">
  import { Bitacora, type BitacoraEvento } from '../lib/api';

  let items = $state<BitacoraEvento[]>([]);
  let actionFilter = $state('');
  let loading = $state(false);
  let error = $state<string | null>(null);

  const ACTION_OPTIONS = [
    '',
    'paciente.desactivar',
    'traslado.bodega_farmacia',
  ];

  async function cargar() {
    loading = true;
    error = null;
    try {
      items = await Bitacora.list(actionFilter || undefined, 100);
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      loading = false;
    }
  }

  function fmtTs(ts?: string | null) {
    if (!ts) return '—';
    try {
      return new Date(ts).toLocaleString('es-GT');
    } catch {
      return ts;
    }
  }

  $effect(() => {
    void actionFilter;
    cargar();
  });
</script>

<section class="view">
  <header class="view-header">
    <div>
      <h2>Bitácora</h2>
      <p class="muted">Eventos de auditoría del tenant</p>
    </div>
    <div class="actions">
      <label class="field">
        <span>Acción</span>
        <select bind:value={actionFilter}>
          <option value="">Todas</option>
          {#each ACTION_OPTIONS.filter(Boolean) as a}
            <option value={a}>{a}</option>
          {/each}
        </select>
      </label>
      <button type="button" class="btn" onclick={cargar} disabled={loading}>
        {loading ? '…' : 'Recargar'}
      </button>
    </div>
  </header>

  {#if error}<p class="err">⚠ {error}</p>{/if}

  <table class="tabla">
    <thead>
      <tr>
        <th>Fecha</th>
        <th>Usuario</th>
        <th>Acción</th>
        <th>Recurso</th>
        <th>Detalle</th>
      </tr>
    </thead>
    <tbody>
      {#each items as e (e.id ?? `${e.ts}-${e.action}-${e.resourceId}`)}
        <tr>
          <td class="mono">{fmtTs(e.ts)}</td>
          <td>{e.actor ?? '—'}</td>
          <td><code>{e.action}</code></td>
          <td>
            <span class="dim">{e.resourceType}</span>
            {#if e.resourceId}<div class="mono">{e.resourceId}</div>{/if}
          </td>
          <td class="detalle">{e.details ?? '—'}</td>
        </tr>
      {:else}
        <tr><td colspan="5" class="empty">{loading ? 'Cargando…' : 'Sin eventos.'}</td></tr>
      {/each}
    </tbody>
  </table>
</section>

<style>
  .view-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem; }
  .view-header h2 { margin: 0; font-size: 1.4rem; color: #111827; }
  .muted { margin: 0.2rem 0 0; color: #6b7280; font-size: 0.85rem; }
  .actions { display: flex; align-items: end; gap: 0.75rem; flex-wrap: wrap; }
  .field { display: flex; flex-direction: column; gap: 0.3rem; }
  .field span { font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.03em; }
  .field select { padding: 0.55rem 0.7rem; border-radius: 8px; border: 1px solid #e5e7eb; font: inherit; font-size: 0.88rem; min-width: 220px; }
  .field select:focus { outline: none; border-color: #16a34a; box-shadow: 0 0 0 3px rgba(22,163,74,0.12); }
  .btn { display: inline-flex; align-items: center; gap: 0.4rem; padding: 0.7rem 1.4rem; border: 0; border-radius: 10px; background: linear-gradient(135deg, #15803d, #16a34a); color: #fff; font: inherit; font-weight: 700; cursor: pointer; box-shadow: 0 4px 14px rgba(22,163,74,0.35); transition: transform 0.15s; }
  .btn:hover:not(:disabled) { transform: translateY(-2px); }
  .btn:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }
  .tabla { width: 100%; border-collapse: collapse; }
  .tabla th { text-align: left; font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.03em; color: #6b7280; padding: 0.6rem 0.8rem; background: #f0fdf4; }
  .tabla td { padding: 0.6rem 0.8rem; border-top: 1px solid #f3f4f6; font-size: 0.9rem; vertical-align: top; color: #111827; }
  .mono { font-family: ui-monospace, monospace; font-size: 0.82rem; }
  .dim { color: #6b7280; font-size: 0.8rem; }
  .detalle { max-width: 360px; word-break: break-word; font-size: 0.82rem; color: #374151; }
  code { font-family: ui-monospace, monospace; font-size: 0.8rem; background: #f0fdf4; padding: 0.1rem 0.35rem; border-radius: 4px; color: #166534; }
  .err { color: #dc2626; }
  .empty { color: #9ca3af; text-align: center; padding: 1.5rem; }
</style>
